import router from '../router';
import { canonicalPath } from './route-params'
import { applyPageTitle } from './page-title'

// 旧查询参数 -> 新路径的迁移表
// 值为需要按顺序拼进路径的查询参数名
// nginx 已对纯 ASCII 的 id / index / targetId 做 301（见 deploy/nginx-redirect.conf），
// 这里主要兜底中文 title 的场景，以及 nginx 规则尚未上线的过渡期
var QUERY_MIGRATIONS = {
  '/product': ['id', 'title'],
  '/app': ['id', 'title'],
  '/AIMenu': ['title', 'id'],
  '/crmcase': ['id', 'title'],
  '/crmcaseinfo': ['id', 'index'],
  '/solution': ['index'],
  '/wbIndustry': ['index'],
  '/WorkBuddy': ['targetId']
}

router.beforeEach((to, from, next) => {
  // 根路径归一到首页。
  // 路由表里父路由写了 redirect: '/home'，但 children 末尾的 catch-all（'*'）
  // 会被规范成 '/*'，其路径段得分高于根路径（根路径没有静态段），
  // 结果 '/' 被 catch-all 抢走，直接落到 404 页——这就是访问域名根路径 404 的原因。
  if (to.path === '/') return next({ path: '/home', replace: true })

  var keys = QUERY_MIGRATIONS[to.path]
  if (keys) {
    var target = canonicalPath(to, to.path, keys)
    if (target) {
      return next({ path: target, replace: true })
    }
  }
  next();
});

router.afterEach((to, from) => {
  // 首次进入时不碰标题：预渲染产物里已经是这条路由的正确标题，
  // 而详情页此刻还没拿到接口数据，改过去只会把对的覆盖成栏目名。
  // 只有站内跳转（SPA 不重新加载文档）才需要手动同步。
  if (!from || !from.name) return
  applyPageTitle(to)
});
